/* eslint-disable */
import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [loadingDetail, setLoadingDetail] = useState(false);

  // 状态选项：Active/Inactive
  const activeOptions = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      setEditRecord(null);
      form.resetFields();
      form.setFieldsValue({ active: 1 });
      setVisible(true);
    },
    // 新增 edit 方法，接收 record 参数
    setModelEdit: async (record) => {
      setEditRecord(record);
      setVisible(true);
      setLoadingDetail(true);
      
      try {
        // 获取详情数据
        const response = await http.get(api.getBankByGroupById, {
          params: { id: record.id },
        });
        
        if (response?.code === "1") {
          const data = response.data;
          form.setFieldsValue({
            bankGroup: data.bankGroup,
            remark: data.remark,
            active: data.active,
          });
        } else {
          message.error(response?.msg || "Failed to load data");
          setVisible(false);
        }
      } catch (err) {
        console.error(err);
        message.error("Failed to load data");
        setVisible(false);
      } finally {
        setLoadingDetail(false);
      }
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);

    try {
      let response;
      
      if (editRecord) {
        // 编辑模式 - 使用 update 接口
        const queryParams = {
          id: editRecord.id,
          bankGroup: values.bankGroup,
          remark: values.remark || "",
          active: values.active ?? 1,
        };
        response = await http.post(api.getBankByGroupUpdate, queryParams);
      } else {
        // 新增模式 - 使用 add 接口
        const queryParams = {
          bankGroup: values.bankGroup,
          remark: values.remark || "",
          active: values.active ?? 1,
        };
        response = await http.post(api.getBankByGroupAdd, queryParams);
      }

      if (response?.code === "1") {
        message.success(editRecord ? "Bank By Group Updated Successfully" : "Bank By Group Added Successfully");
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
        onSuccess && onSuccess();
      } else {
        message.error(response?.msg || (editRecord ? "Update failed" : "Add failed"));
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            {editRecord ? "EDIT BANK BY GROUP" : "ADD BANK BY GROUP"}
          </Typography.Title>
        </Flex>
      }
      width="40%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setEditRecord(null);
      }}
      maskClosable={false}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
          <Button
            key="back"
            onClick={() => {
              setVisible(false);
              form.resetFields();
              setEditRecord(null);
            }}
          >
            Cancel
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={loading || loadingDetail}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                  <Form.Item
                    name="bankGroup"
                    label="Bank Group"
                    rules={[
                      {
                        required: true,
                        message: "Please enter a bank group name",
                      },
                    ]}
                  >
                    <Input placeholder="Please enter a bank group name." allowClear />
                  </Form.Item>

                  <Form.Item
                    name="remark"
                    label="Remark"
                  >
                    <Input placeholder="Please enter a remark." allowClear />
                  </Form.Item>

                  <Form.Item
                    name="active"
                    label="Active"
                    rules={[{ required: true, message: "Please select active status" }]}
                  >
                    <Select
                      placeholder="Select Active Status"
                      options={activeOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;